import EventBus from '@/event-bus';
import _Singleton from '@/tools/singleton';
import urlTool from '@/tools/url';
import stripHtml from '@/helpers/stripHtml';
import Shop from '@/shop';

import options from '@/ui/ui_ajax-reviews/reviews/default-selectors.json';
import defaultSettings from '@/ui/ui_ajax-reviews/reviews/default-settings.json';
import methods from '@/ui/ui_ajax-reviews/methods/index';

/**
 * @class
 * @private
 *
 * @description
 * DOM + AjaxReviews
 */
const AjaxReviewsDOM = function() {
  const self = this;

  self.options = options;
  self.defaultSettings = defaultSettings;
  self.methods = methods;

  document.addEventListener('DOMContentLoaded', function() {
    self._init();
    self._loadReviewsListOnEvent();
  });
};

/**
 * Обновление
 * @method
 */
AjaxReviewsDOM.prototype.update = function() {
  this._init();
};

/**
 * Инициализация
 * @method
 * @private
 */
AjaxReviewsDOM.prototype._init = function() {
  const self = this;
  const ajaxProductNodes = document.querySelectorAll(self.options.ajaxReviews.attr);
  if (!ajaxProductNodes.length) { return; }

  Array.from(ajaxProductNodes).forEach((ajaxProductNode) => {
    const noInited = !ajaxProductNode.classList.contains(self.defaultSettings.classes.ajaxProductIsInit);

    let options = {};
    const templates = self._getTemplates(ajaxProductNode);

    if (noInited && options.initOnLoadPage == 'true' && templates.product) {
      self._renderReviewsList(ajaxProductNode, templates);
    }
  });
};

/**
 * Загрузка отдельной категории
 * @method
 * @private
 */
AjaxReviewsDOM.prototype._loadReviewsListOnEvent = function() {
  const self = this;
  EventBus.subscribe('ui-ajax-reviews:load-reviews-list', function(ajaxReviewsListNode) {
    const ajaxReviewsNode = ajaxReviewsListNode.closest(self.options.ajaxReviews.attr);

    if (!ajaxReviewsNode) { return false; }

    const templates = self._getTemplates(ajaxReviewsNode);

    const noInited = !ajaxReviewsListNode.classList.contains(self.defaultSettings.classes.ajaxReviewsIsInit);

    if (noInited && templates.preview) {
      self._renderReviewsList(ajaxReviewsListNode, templates);
    }
  });
};

/**
 * @private
 *
 * @description
 * Получение данных
 */
AjaxReviewsDOM.prototype._getReviews = function(reviewsType, options = {}) {
  return new Promise(async resolve => {
    let url = new URL(location.origin + `/front_api/accounts/reviews.json`);

    const lang = urlTool.getKeyValue('lang') || '';
/*
    if (options.limit) {
      url.searchParams.append('per_page', options.limit);
    }
*/
    if (reviewsType.trim() === 'nospam') {
      url.searchParams.append('spam', false);
    }

    url.searchParams.append('created_asc', options.sort);
    url.searchParams.append('lang', lang);
    url.searchParams.append('unique', options.unique);
    url.searchParams.append('per_page', options.limit);

    if (options.rating != 0) {
      let stars = [ 1, 2, 3, 4, 5 ];
      const rating = stars.slice(options.rating - 1).join(',');

      url.searchParams.append('rating', rating);
    }

    const reviews = await fetch(url).then(response => response.json());

    resolve(reviews);
  });
};

/**
 * @private
 *
 * @description
 * Формируем список отзывов
 */
AjaxReviewsDOM.prototype._renderReviewsList = async function(reviewsListNode, templates) {
  const self = this;

  let options = {};

  const optionsData = reviewsListNode.dataset[self.options.ajaxReviewsList.data];

  if (optionsData) { options = JSON.parse(optionsData); }

  const collectionHandle = options.reviewscollection;

  if (!collectionHandle) { return; }

  (async () => {
    self.methods._toggleLoadingState(
      reviewsListNode,
      self.options.ajaxReviews.attr,
      self.defaultSettings.classes.ajaxReviewsIsLoading
      );

    const categoryData = await self._getReviews(collectionHandle, {
      limit: options.limit,
      rating: options.rating,
      sort: options.sort,
      unique: options.unique.trim()
    });

    const ajaxReviewsNode = reviewsListNode.closest(self.options.ajaxReviews.attr);

    if (categoryData.length == 0) {
      ajaxReviewsNode.hide()
    }

    if (options.limit) {
      categoryData.splice(options.limit);
    }

    try {
      categoryData.forEach(async(item) => {
        reviewsListNode.appendChild(self._createReview(item, options, templates));
      });

      reviewsListNode.classList.add(self.defaultSettings.classes.ajaxReviewsIsInit);

      EventBus.publish('init-reviews:ui-ajax-reviews', { reviewsListNode: reviewsListNode });
    } catch (err) {
      console.error(err);
    } finally {
      self.methods._toggleLoadingState(
        reviewsListNode,
        self.options.ajaxReviews.attr,
        self.defaultSettings.classes.ajaxReviewsIsLoading
        );
    }
  })();
};

/**
 * @private
 *
 * @description
 * Формируем отзыв
 */
AjaxReviewsDOM.prototype._createReview = function(itemData, options, templates) {
  const self = this;

  const reviewItem = self.methods._getNodeFromTemplate(templates.preview, self.options.ajaxReviewsListItem.attr);

  if (!reviewItem) { return; }

  const author = itemData.author;
  const product = itemData.title;
  const productUrl = itemData.url;
  const content = itemData.content;
  const rating = itemData.rating;
  const date = itemData.created_at;
  const replied = itemData.replied_q;
  const reply = itemData.manager_reply;
  const replydate = itemData.replied_at;

  const reviewAuthorNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemAuthor.attr);
  const reviewProductNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemProduct.attr);
  const reviewImgNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemImage.attr);
  const reviewProductUrlNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemProductUrl.attr);
  const reviewContentNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemContent.attr);
  const reviewRatingNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemRating.attr);
  const reviewDateNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemDate.attr);
  const reviewReplyContainerNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemReplyContainer.attr);
  const reviewReplyNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemReply.attr);
  const reviewReplyDateNodes = self.methods._getFieldNodes(reviewItem, self.options.ajaxReviewsListItemReplyDate.attr);

  // Автор отзыва
  reviewAuthorNodes.forEach((item) => {
    item.textContent = stripHtml(author);
  });

  // Продукт на который написан отзыв
  reviewProductNodes.forEach((item) => {
    item.textContent = stripHtml(product);
  });

  // Фото продукта на который написан отзыв

  reviewImgNodes.forEach((item) => {
    const firstImage = itemData.first_image;
    const reviewPicture = self.methods._getNodeFromTemplate(templates.previewImage, this.options.ajaxReviewsListItemPicture.attr);
    item.appendChild(self._createImage(reviewPicture, firstImage, firstImage.title || product));
  });

  // Ссылка на продукт, на который написан отзыв
  reviewProductUrlNodes.forEach((item) => {
    item.setAttribute('href', productUrl);
  });

  // Текст отзыва
  reviewContentNodes.forEach((item) => {
    item.textContent = stripHtml(content);
  });

  // Звезды рейтинга

  reviewRatingNodes.forEach((item) => {
    if (rating != null) {
      item.innerHTML += self.methods._renderStars(rating).join('');
    }
  });

  // Дата отзыва
  reviewDateNodes.forEach((item) => {
    item.innerHTML += self.methods._renderDate(date)
  });

   // Удаление блока с ответом, если на отзыв не ответили
  if (!replied) {
    reviewReplyContainerNodes.forEach((item) => {
      item.remove();
    });
  }

  // Ответ менеджера
  reviewReplyNodes.forEach((item) => {
    item.textContent = stripHtml(reply);
  });

  // Дата ответа менеджера
  reviewReplyDateNodes.forEach((item) => {
    item.innerHTML += self.methods._renderDate(replydate)
  });

  return reviewItem;
};

/**
 * @private
 *
 * @description
 * Загружаем картинки
 */
AjaxReviewsDOM.prototype._createImage = function(productPicture, image, title = '', index) {
  const self = this;

  const pictureSources = self.methods._getFieldNodes(productPicture, 'source');
  const pictureImg = productPicture.querySelector('img');

  pictureSources.forEach((item) => {
    const url = self.methods._imageUrlForPictureSource(
      image,
      item,
      self.options.ajaxReviewsImageResizingRulesIndex.data
    );

    // Плавно переходим на нативный lazyload, условие нужно чтобы ничего не сломать в кастомных виджетах
    if (item.classList.contains('lazyload') && typeof LazyLoad === 'function') {
      item.setAttribute('data-srcset', url);
    } else {
      item.setAttribute('srcset', url);
    }
  });

  if (pictureImg) {
    const url = self.methods._imageUrlForPictureSource(
      image,
      pictureImg,
      self.options.ajaxReviewsImageResizingRulesIndex.data
    );

    let classForSwitch = null;
    if (index) { classForSwitch = `product-preview__img-${index}`; }

    // Плавно переходим на нативный lazyload, условие нужно чтобы ничего не сломать в кастомных виджетах
    if (pictureImg.classList.contains('lazyload') && typeof LazyLoad === 'function') {
      pictureImg.setAttribute('data-src', url);
    } else {
      pictureImg.setAttribute('src', url);
    }

    pictureImg.setAttribute('alt', title);
    pictureImg.setAttribute('title', title);
    if (classForSwitch) {
      pictureImg.classList.add(classForSwitch);
    }
  }

  return productPicture;
};

AjaxReviewsDOM.prototype._getTemplates = function(ajaxReviewsNode) {
  const self = this;

  const templates = {};

  templates.preview = ajaxReviewsNode.querySelector(self.options.ajaxReviewsListItemTemplate.attr);
  templates.previewImage = ajaxReviewsNode.querySelector(self.options.ajaxReviewsListItemImageTemplate.attr);

  return templates;
};

export default _Singleton(AjaxReviewsDOM).getInstance();
